// extracted by mini-css-extract-plugin
module.exports = {"optionInfoBox":"RefundabilityButton_optionInfoBox__Dn6KY","inlineText":"RefundabilityButton_inlineText__n3UGX"};